import React from 'react';
import {Route, Routes} from 'react-router-dom';
import HomePage from "../pages/home/HomePage";
import VipCenter from "../pages/vip/VipCenter";
import ConsumptionRecordList from "../pages/vip/ConsumptionRecordList";
import ChargingStandardList from "../pages/vip/ChargingStandardList";
import VipChargingList from "../pages/vip/VipChargingList";
import WorkFlowReplication from "../pages/coze/WorkFlowReplication";
import AgentList from "../pages/coze/AgentList";
import CopyTaskList from "../pages/coze/CopyTaskList";
import CozeSpace from "../pages/coze/CozeSpace";
import AgentInfo from "../pages/coze/AgentInfo";
import WorkFlowExecuteRecordList from "../pages/coze/WorkFlowExecuteRecordList";
import JianYingAssistant from "../pages/JianYingAssistant";
import PromotionPage from "../pages/invite/PromotionPage";
import AgentExecuteRecordList from "../pages/coze/AgentExecuteRecordList";
import CourseList from "../pages/course/CourseList";
import CourseInfo from "../pages/course/CourseInfo";
import InviteTeamList from "../pages/invite/InviteTeamList";
import WithdrawHistoryList from "../pages/invite/WithdrawHistoryList";
import AmountHistoryList from "../pages/invite/AmountHistoryList";
import CheckInPage from "../pages/sign/CheckInPage";

const RoutesComponent = ({userProfileRef}) => (
    <Routes>
        <Route path="/" element={<HomePage userProfileRef={userProfileRef}/>}/>
        <Route
            path="/home"
            element={<HomePage userProfileRef={userProfileRef}/>}
        />
        <Route
            path="/vipCenter"
            element={
                <VipCenter/>
            }
        />

        <Route
            path="/ConsumptionRecordList"
            element={
                <ConsumptionRecordList/>
            }
        />
        <Route
            path="/ChargingStandardList"
            element={
                <ChargingStandardList/>
            }
        />
        <Route
            path="/VipChargingList"
            element={
                <VipChargingList/>
            }
        />
        <Route
            path="/cozeList"
            element={
                <WorkFlowReplication userProfileRef={userProfileRef}/>
            }
        >
            <Route index element={<AgentList/>}/>
            <Route path="AgentList" element={<AgentList/>}/>
            <Route path="CopyTaskList" element={<CopyTaskList/>}/>
            <Route path="CozeSpace" element={<CozeSpace/>}/>
        </Route>
        <Route
            path="/AgentInfo/:id"
            element={
                <AgentInfo/>
            }
        />
        <Route path="/WorkFlowExecuteRecordList"
               element={
                   <WorkFlowExecuteRecordList/>
               }
        />
        <Route path="/AgentExecuteRecordList"
               element={
                   <AgentExecuteRecordList/>
               }
        />
        <Route path="/JianYingAssistant"
               element={
                   <JianYingAssistant/>
               }
        />
        <Route path="/promotion"
               element={
                   <PromotionPage/>
               }
        />
        <Route path="/inviteTeamList"
               element={
                   <InviteTeamList/>
               }
        />
        <Route path="/withdrawHistoryList"
               element={
                   <WithdrawHistoryList/>
               }
        />
        <Route path="/amountHistoryList"
               element={
                   <AmountHistoryList/>
               }
        />
        <Route path="/courseList"
               element={
                   <CourseList/>
               }
        />
        <Route path="/courseInfo/:id"
               element={
                   <CourseInfo/>
               }
        />
        <Route path="/sign"
               element={
                   <CheckInPage/>
               }
        />
    </Routes>
);

export default RoutesComponent;